export const MAX_VARIANT_DOTS_ON_TILE = 4;
